/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BREEDER v2 API
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  LogoutResult
} from '../model';

import { apiFetch } from '../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getAuthLogoutUrl = () => {




  return `/bff/logout`
}

/**
 * @summary End the session; the browser then navigates to logout_url (Keycloak)
 */
export const authLogout = async ( options?: Parameters<typeof apiFetch>[1]): Promise<LogoutResult> => {

  return apiFetch<LogoutResult>(getAuthLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAuthLogoutMutationKey = () => ['authLogout'] as const;

export const getAuthLogoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogout>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authLogout>>, TError,void, TContext> => {

const mutationKey = getAuthLogoutMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authLogout>>, void> = () => {


          return  authLogout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof authLogout>>>

    export type AuthLogoutMutationError = unknown


    /**
 * @summary End the session; the browser then navigates to logout_url (Keycloak)
 */
export const useAuthLogout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogout>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authLogout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAuthLogoutMutationOptions(options), queryClient);
    }
